import { WiDEObjectType, ComponentDefinition } from '../../models';

export interface ButtonDefinition {
    title: string;
    icon: string;
    property: string;
    view: string;
    objectType: WiDEObjectType;
}

class SynchronizationButtonsController implements angular.IComponentController {
    buttons: ButtonDefinition[];
    static $inject = [];

    $onInit() {
        this.buttons = [
            {
                title: 'Overview',
                icon: 'fa-th-large',
                property: 'overview',
                view: 'overview',
                objectType: WiDEObjectType.Group
            }, {
                title: 'Trend',
                icon: 'fa-line-chart',
                property: 'trend',
                view: 'trend',
                objectType: WiDEObjectType.TrendSeries
            }, {
                title: 'Identifiers',
                icon: 'fa-table',
                property: 'identifiers',
                view: 'identifiers',
                objectType: WiDEObjectType.Identifier
            }, {
                title: 'States',
                icon: 'fa-barcode',
                property: 'states',
                view: 'states',
                objectType: WiDEObjectType.GroupState
            }, {
                title: 'Rules',
                icon: 'fa-signal',
                property: 'rules',
                view: 'rules',
                objectType: WiDEObjectType.Rule
            }, {
                title: 'Alarms',
                icon: 'fa-bell',
                property: 'alarms',
                view: 'alarms',
                objectType: WiDEObjectType.Alarm
            }
        ];
    }
}

export const wtSynchronizationButtons: ComponentDefinition = {
    componentId: 'wtSynchronizationButtons',
    controller: SynchronizationButtonsController,
    template: require('./synchronizationButtons.component.html'),
    controllerAs: 'vm',
    bindings: {
        badges: '<',
        showIgnored: '<',
        buttons: '=',
        selectButton: '&',
        button: '<'
    }
};